import stCashDeckAuth from './cashDeckAuth.component';
import stCashDeckButton from './cashDeckButton.component';

export default angular
  .module('st.Integrations.CashDeck', [])
  .component('stCashDeckAuth', stCashDeckAuth)
  .component('stCashDeckButton', stCashDeckButton)
  .service('cashDeckService', ($http, dataService, CASH_DECK) => ({
    create: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, CASH_DECK.API.CREATE, params)
  }))
  .constant('CASH_DECK', {
    API: {
      CREATE: '/api/v1/integrations/cash-deck/create'
    }
  });
